import {
  AuthGuard,
  AuthLayout,
  CreateCategoryManagement,
  Layout,
  PublicLayout,
} from "@components";
import {
  AddOwner,
  AfterPayment,
  ControlCenter,
  Dashboard,
  DirectMessagesPage,
  ErrorPage,
  Finance,
  FinanceDetails,
  FreemiumOnboarding,
  GuestManagementPage,
  GuestPoral,
  LandingPage,
  LockDetails,
  LocksListing,
  LocksManagement,
  Login,
  ManagePlan,
  Messaging,
  NewCalenderPage,
  NewPropertyProfile,
  OwnerEdit,
  OwnerInsights,
  OwnerManagementPage,
  OwnerPortal,
  Passwordchange,
  PasswordCode,
  PasswordForget,
  AddProperty,
  PropertiesManagement,
  PropertyProfile,
  Register,
  ReservationManagementPage,
  ResetPassword,
  Settings,
  SignupPage,
  Subscribe,
  TaskManagetmenPage,
  UserManagementPage,
  WebsiteBuilder,
} from "@pages";
//@ts-nocheck:

import { createBrowserRouter, Navigate, RouteObject } from "react-router-dom";

import AfterRenewalPaymentPage from "../pages/AfterRenewalPaymentPage";
import Automation from "../pages/Automation/index";
import CategoryManagementPage from "../pages/CategoryManagementPage";
import { ReservationInfo } from "../pages/ReservationInfo";
import AllApplications from "../pages/AppMarket/components/AllApplications";
import AppDetails from "../pages/AppMarket/components/AppDetails";
import EnableMarketPlace from "../pages/AppMarket/components/EnableMarketPlace";
import AppLinkedSuccess from "../pages/AppMarket/components/AppLinkedSuccess";
import RegisterOtp from "../../src/pages/signup/SignupComponents/RegisterOtp";
import ChoosePlan from "../pages/Subscribe/SubscribtionBundle/ChoosePlan";
import ChoosePlanDetails from "../pages/Subscribe/SubscribtionBundleForm/ChoosePlanDetails";
import OnBoardingJourny from "../pages/OnBoardingJourny";
import PaymentStatus from "../pages/GuestPortal/PaymentStatus";
import GuestPortalPaymentFail from "../pages/GuestPortal/GuestPortalPaymentFail";
import GuestPortalSummary from "../pages/GuestPortal/GuestPortalSummary";
import SignedAgreementPage from "../pages/GuestPortal/SignedAgreementPage";
import GeneraSetting from "../pages/PropertySetting/index";
// Channels module views
import {
  ChannelsListView as ChannelsPage,
  ConnectChannelView as ConnectChannelPage,
  ImportUnitsView as ImportUnitsPage,
  ManageChannelView as ManageChannelPage,
  UnitsMappingView as UnitsMappingPage,
  PropertiesListView as PropertiesPage,
} from "../modules/channels";

export const useRouterLinks = () => {
  const routerObjects: RouteObject[] = [
    {
      path: "/",
      element: (
        <PublicLayout>
          <LandingPage />
        </PublicLayout>
      ),
    },

    {
      path: "/reservation-info/:id",
      element: <ReservationInfo />,
    },
    
    {
      path: "/owner-portal",
      element: <OwnerPortal />,
    },
    
    {
      path: "/login",
      element: <Login />,
    },
    {
      // Public freemium self-serve onboarding wizard (flag: VITE_FREEMIUM_ONBOARDING)
      path: "/start",
      element: <FreemiumOnboarding />,
    },
    {
      path: "/signup",
      element: <SignupPage />,
    },
    {
      path: "/register",
      element: <SignupPage />,
    },
    {
      path: "/forget-password",
      element: <PasswordForget />,
    },
    {
      path: "/forget-password-code/:id",
      element: <PasswordCode />,
    },
    {
      path: "/change-password",
      element: <Passwordchange />,
    },
    {
      path: "/choose-plan",
      element: <ChoosePlan />,
    },
    {
      path: "/choose-plan/:id/:period",
      element: <ChoosePlanDetails />,
    },
    {
      path: "/register/otp/:mail",
      element: <RegisterOtp />,
    },
    {
      // Freemium add-property — standalone full page (own top bar, no sidebar),
      // matching Figma 2037:3179. Reached from the Properties list add card.
      path: "/properties-management/add",
      element: (
        <AuthGuard
          requiredPermission={"showListingManagement"}
          allowInactive
          titleKey={"PROPERTIES_MANAGEMENT.ADD_FORM.PAGE_TITLE"}
        >
          <AddProperty />
        </AuthGuard>
      ),
    },
    {
      path: "/*",
      element: <Layout />,
      children: [
        {
          path: "user-management",
          element: (
            <AuthGuard
              requiredPermission={"showTeamManagement"}
              titleKey="UserManagement.UserManagement"
            >
              <UserManagementPage />
            </AuthGuard>
          ),
        },
        {
          path: "website-builder",
          element: (
            <AuthGuard
              requiredPermission={"showYourWebsite"}
              titleKey="website builder"
            >
              <WebsiteBuilder />
            </AuthGuard>
          ),
        },
        {
          path: "calendar",
          element: (
            <AuthGuard
              requiredPermission={"showCalendar"}
              titleKey={"DASHBOARD.CALENDAR"}
            >
              <NewCalenderPage />
            </AuthGuard>
          ),
        },
        {
          path: "finance",
          children: [
            {
              index: true,
              element: <Finance />,
            },
            {
              path: "accounting",
              element: (
                <AuthGuard
                  requiredPermission={"showAccounting"}
                  titleKey={"FINANCE.TITLE"}
                >
                  <FinanceDetails />
                </AuthGuard>
              ),
            },
            {
              path: "accounting/:id",
              element: (
                <AuthGuard titleKey={"FINANCE.TITLE"}>
                  <FinanceDetails />
                </AuthGuard>
              ),
            },
          ],
        },
        {
          path: "manage-plan",
          element: (
            <AuthGuard
              requiredPermission={"showSubscriptionManagement"}
              titleKey={"MANAGE_PLAN.TITLE"}
            >
              <ManagePlan />
            </AuthGuard>
          ),
        },
        {
          path: "v1/meta/airbnb/auth_redirect",
          children: [
            {
              index: true,
              element: (
                <AuthGuard
                  allowInactive
                  titleKey={"PROPERTIES_MANAGEMENT.TITLE"}
                >
                  <PropertiesManagement />
                </AuthGuard>
              ),
            },
          ],
        },
        {
          path: "properties-management", //https://staging.channex.io/api/v1/meta/airbnb/auth_redirect?success=true&channel_id=f4f7f5b9-0ded-457f-9b4a-0f2399ef85a7&token=
          children: [
            {
              index: true,
              element: (
                <AuthGuard
                  requiredPermission={"showListingManagement"}
                  allowInactive
                  titleKey={"PROPERTIES_MANAGEMENT.TITLE"}
                >
                  <PropertiesManagement />
                </AuthGuard>
              ),
            },
            {
              path: "v1/meta/airbnb/auth_redirect",
              element: (
                <AuthGuard
                  allowInactive
                  titleKey={"PROPERTIES_MANAGEMENT.TITLE"}
                >
                  <PropertiesManagement />
                </AuthGuard>
              ),
            },
            {
              path: "profile/:id/new",
              element: (
                <AuthGuard titleKey={"PROPERTIES_MANAGEMENT.TITLE"}>
                  <NewPropertyProfile />
                </AuthGuard>
              ),
            },
            {
              path: "profile/:id",
              element: (
                <AuthGuard titleKey={"PROPERTIES_MANAGEMENT.TITLE"}>
                  <PropertyProfile />
                </AuthGuard>
              ),
            },
            {
              path: "general-settings/:id",
              element: <GeneraSetting />,
            },
          ],
        },
        {
          path: "locks-management",
          children: [
            {
              index: true,
              element: <Navigate to={"control"} />,
            },
            {
              path: "control",
              element: (
                <AuthGuard titleKey={"LOCKS.TITLE"}>
                  <LocksManagement />
                </AuthGuard>
              ),
            },
            {
              path: "control/:id",
              element: (
                <AuthGuard titleKey={"LOCKS.TITLE"}>
                  <LockDetails />
                </AuthGuard>
              ),
            },
            {
              path: "listing",
              element: (
                <AuthGuard
                  requiredPermission={"showLockManagement"}
                  titleKey={"LOCKS.TITLE"}
                >
                  <LocksListing />
                </AuthGuard>
              ),
            },
          ],
        },
        {
          path: "settings",
          element: (
            <AuthGuard
              requiredPermission={"showSettings"}
              titleKey={"SETTINGS"}
            >
              <Settings />
            </AuthGuard>
          ),
        },
        {
          path: "chooseChannel",
          element: (
            <AuthGuard titleKey="choose Channel">
              <OnBoardingJourny />
            </AuthGuard>
          ),
        },
        {
          path: "dashboard",
          element: (
            <AuthGuard
              requiredPermission={["showDashboard", "showYourWebsite"]}
              titleKey="DASHBOARD.TITLE"
            >
              <Dashboard />
            </AuthGuard>
          ),
        },
        {
          path: "messaging",
          element: (
            <AuthGuard
              requiredPermission={"showYourWebsite"}
              titleKey={"MESSAGING.TITLE"}
            >
              <Messaging />
            </AuthGuard>
          ),
        },
        {
          path: "reservation-management",
          element: (
            <AuthGuard
              requiredPermission={"showReservations"}
              titleKey="reservation-management"
            >
              <ReservationManagementPage />
            </AuthGuard>
          ),
        },
        {
          path: "guest-management",
          element: (
            <AuthGuard
              requiredPermission={"showGuestManagement"}
              titleKey="guest-management"
            >
              <GuestManagementPage />
            </AuthGuard>
          ),
        },
        {
          path: "owner-management",
          element: (
            <AuthGuard
              requiredPermission={"showOwnerManagement"}
              titleKey="owner-management"
            >
              <OwnerManagementPage />
            </AuthGuard>
          ),
        },
        {
          path: "automation",
          element: (
            <AuthGuard
              requiredPermission={"showAutomation"}
              titleKey="automation"
            >
              <Automation />
            </AuthGuard>
          ),
        },
        {
          path: "apps",
          element: (
            <AuthGuard
              requiredPermission={"showAppMarketplace"}
              titleKey="app-market"
            >
              <AllApplications />
            </AuthGuard>
          ),
        },
        {
          path: "apps-Details/:id",
          element: (
            <AuthGuard titleKey="AppDetails">
              <AppDetails />
            </AuthGuard>
          ),
        },
        {
          path: "appLinkedSuccess/:id",
          element: (
            <AuthGuard titleKey="appLinkedSuccess">
              <AppLinkedSuccess />
            </AuthGuard>
          ),
        },
        {
          path: "apps-MarketPlace/:id",
          element: (
            <AuthGuard titleKey="Enable-Market-Place">
              <EnableMarketPlace />
            </AuthGuard>
          ),
        },

        {
          path: "add-owner",
          element: (
            <div>
              <AddOwner />
            </div>
          ),
        },
        {
          path: "owner-insights/:id",
          element: (
            <div>
              <OwnerInsights />
            </div>
          ),
        },
        {
          path: "owner-edit/:id",
          element: (
            <div>
              <OwnerEdit />
            </div>
          ),
        },

        {
          path: "category-management",
          element: (
            <AuthGuard titleKey="category-management">
              <CategoryManagementPage />
            </AuthGuard>
          ),
        },
        {
          path: "create-category-management",
          element: <CreateCategoryManagement />,
        },
        {
          path: "direct-messages",
          element: (
            <AuthGuard
              requiredPermission={"showInbox"}
              titleKey="direct-messages"
            >
              <DirectMessagesPage />
            </AuthGuard>
          ),
        },
        {
          path: "task-management",
          element: (
            <AuthGuard
              requiredPermission={"showTaskManagement"}
              titleKey="task-management"
            >
              <TaskManagetmenPage />
            </AuthGuard>
          ),
        },
        {
          path: "channels",
          children: [
            {
              index: true,
              element: (
                <AuthGuard titleKey="CHANNELS.PAGE_TITLE">
                  <ChannelsPage />
                </AuthGuard>
              ),
            },
            {
              path: ":integration/connect",
              element: (
                <AuthGuard titleKey="CHANNELS.CONNECT_ACCOUNT">
                  <ConnectChannelPage />
                </AuthGuard>
              ),
            },
            {
              path: ":integration/units/import",
              element: (
                <AuthGuard titleKey="CHANNELS.IMPORT_UNITS">
                  <ImportUnitsPage />
                </AuthGuard>
              ),
            },
            {
              path: ":integration/manage",
              element: (
                <AuthGuard titleKey="CHANNELS.MANAGE_CHANNEL">
                  <ManageChannelPage />
                </AuthGuard>
              ),
            },
            {
              path: "units-mapping",
              element: (
                <AuthGuard titleKey="CHANNELS.UNITS_MAPPING.PAGE_TITLE">
                  <UnitsMappingPage />
                </AuthGuard>
              ),
            },
            {
              path: "properties",
              element: (
                <AuthGuard titleKey="CHANNELS.PROPERTIES.PAGE_TITLE">
                  <PropertiesPage />
                </AuthGuard>
              ),
            },
          ],
        },
        {
          path: "*",
          element: <Navigate to={"/404"} />,
        },
      ],
    },
    {
      path: "guest/:id",
      element: <GuestPoral />,
    },

    {
      path: "/payment",
      element: (
        <AuthLayout>
          <AfterPayment type={"loading"} />
        </AuthLayout>
      ),
    },

    {
      path: "/payment-renewal",
      element: (
        <AuthLayout>
          <AfterRenewalPaymentPage type="loading" />
        </AuthLayout>
      ),
    },
    {
      path: "/fail-payment-renewal",
      element: (
        <AuthLayout>
          <AfterRenewalPaymentPage type="fail" />
        </AuthLayout>
      ),
    },
    {
      path: "/success-payment-renewal",
      element: (
        <AuthLayout>
          <AfterRenewalPaymentPage type="success" />
        </AuthLayout>
      ),
    },
    {
      path: "/success-payment",
      element: <AfterPayment type={"success"} />,
    },
    {
      path: "/failed-payment",
      element: (
        <AuthLayout>
          <AfterPayment type={"fail"} />
        </AuthLayout>
      ),
    },

    {
      path: "/resetpassword",
      element: (
        <AuthLayout logo>
          <ResetPassword />
        </AuthLayout>
      ),
    },
    {
      path: "/subscribe/:packageId/:numberOfProperties/",
      element: (
        <div>
          <Subscribe />
        </div>
      ),
    },
    {
      path: "/404",
      element: (
        <div className={"min-h-screen flex"}>
          <ErrorPage code={404} />
        </div>
      ),
    },

    {
      path: "/guest/payment-status/:id",
      element: <PaymentStatus />,
    },
    {
      path: "/guest/fail",
      element: <GuestPortalPaymentFail />,
    },
    {
      path: "/guest/summary-page/:id",
      element: <GuestPortalSummary />,
    },
    // MS-591 — «عرض الاتفاقية الموقّعة» in the confirmation email. The path is hardcoded in the
    // email backend (SendReservationConfirmationEmailJob), so it has to match exactly. Public:
    // the :token is the MS-541 access token and is itself the credential. It does not shadow
    // "guest/:id" — React Router ranks by specificity, and three segments beat two.
    {
      path: "/guest/agreement/:token",
      element: <SignedAgreementPage />,
    },
  ];

  const router = createBrowserRouter(routerObjects);

  return { router };
};
